import { Text } from '@sloyd/ui';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Gallery = styled.div`
  flex: 1;
  display: flex;
`;

export const Explain = styled(Text)`
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: rgb(7, 13, 32);
  padding: 5px;
  border-radius: 10px;
`;
